import {apiPath}        from '@/util/http';
import {naturalSortAsc} from '@/util/sort';
import alert            from '@/util/alert';

export default {
    data: () => ({
        availableTags: [],
        form: {
            tags: []
        }
    }),
    methods: {
        addTag(newTag) {
            const tag = {
                id: -1 * Math.floor((Math.random() * 10000)), // Random negative id, will be auto-generated in backend
                nom: newTag
            };
            this.availableTags.push(tag);
            this.form.tags.push(tag);
        },
        loadAvailableTags() {
            alert.loading()
                .then(() => this.axios.get(apiPath('get_all_borrowable_tags')))
                .then(response => this.availableTags = response.data.sort((a, b) => naturalSortAsc(a.nom, b.nom)))
                .catch(() => this.$toaster.error('Impossible de récupérer la liste des tags'))
                .finally(alert.stopLoading);
        }
    },
    mounted() {
        this.loadAvailableTags();
    }
};